<template>
  <v-app>
    <div v-if="$store.getters.getIsLoggedIn">
      <Navigation />
      <Header /> 
    </div>     
    <v-main style="background-color: var(--v-contentBackground-base);">
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>
    <Snackbar />
  </v-app>
</template>

<script>
import Header from './components/Header'
import Navigation from './components/Navigation'
import Snackbar from './components/Snackbar'

import store from './store/store'
import i18n from './assets/i18n/i18n'

export default {
  name: 'App',
  components: {
    Header,
    Navigation,
    Snackbar
  }
}
</script>

<style lang="scss">
 * {
    &::-webkit-scrollbar {
      width: 7px;
      background: rgb(245, 245, 245);
    }

    &::-webkit-scrollbar-thumb {
      background: #c7c7c7;
    }
  }

  .v-input--selection-controls__input input {
    opacity: 0.01 !important;
    width: 100% !important;
    height: 100% !important;
    position: absolute !important;
    z-index: 10 !important;
  }


</style>